import useBodyScrollLock from "hooks/useBodyScrollLock";

/**
 * 공용 바텀 모달.
 *
 * onConfirm 을 넘기면 [취소]와 [확인] 두 버튼이 되고, 확인을 누를 때 그 함수가 불린다.
 * 안 넘기면 예전 그대로 확인 버튼 하나가 닫기만 한다 — 기존 호출부는 손댈 필요가 없다.
 */
const CommonModal = ({isShow, closeModal, content, onConfirm, confirmText = "확인", cancelText = "취소"}) => {
    const {title, body} = content;
    useBodyScrollLock(isShow);

    return (
        <div data-id="modal-bottom" className={'modal-bottom-dimmed' + (isShow ? ' is-show' : '')}>
            <div className="modal-bottom">
                <div className="tit-box">
                    <p>{title}</p>
                    <button onClick={closeModal} type="button" className="ico-btn">
                        <i className="close"></i>
                        <span className="visually-hidden"> 닫기 </span>
                    </button>
                </div>
                {body &&
                    <div className="con-box">
                        <p className="t-body" style={{ wordBreak: "keep-all", whiteSpace: "pre-line", textAlign: "center" }}>{body}</p>
                    </div>}
                <div className="btn-group">
                    {onConfirm && (
                        <button type="button" onClick={closeModal} className="btn-md outlined">{cancelText}</button>
                    )}
                    <button type="button" onClick={onConfirm || closeModal} className=" btn-md filled primary">
                        {onConfirm ? confirmText : "확인"}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default CommonModal;